import { CalendarIcon } from '@radix-ui/react-icons'
import { format } from 'date-fns'
import { Button } from 'ui/button'
import { Calendar } from 'ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover'
import { cn } from 'lib/utils'

const DatePicker = ({
    date,
    setDate,
    className,
    label
}: {
    className?: string
    date: Date | undefined
    label?: string
    setDate: (date: Date | undefined) => void
}) => {
    const handleDateSelect = (newDate: Date | undefined) => {
        setDate(newDate)
    }

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={'outline'}
                    className={cn(
                        'h-11 w-full justify-start text-left font-normal',
                        !date && 'text-muted-foreground',
                        className
                    )}
                >
                    <CalendarIcon className='mr-2 h-4 w-4' />
                    {date ? format(date, 'PPP') : <span>{label}</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className='w-auto p-0' align='start'>
                <Calendar mode='single' selected={date} onSelect={handleDateSelect} />
            </PopoverContent>
        </Popover>
    )
}

export default DatePicker
